import { API_GATEWAY_ENDPOINT } from "../constants/api";

export const getMotivosJustificaciones = async (id_justificacion_grupo) => {
    try{
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");
  
      var raw = JSON.stringify({
        id_justificacion_grupo
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };

      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/motivos",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const getGruposMotivosJustificaciones = async (id_area_operacion) => {
    try{
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");


      var raw = JSON.stringify({
        id_area_operacion
      });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/-motivos-grupo",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const getMaquinasByIdAreaOperacion = async (id_area_operacion) => {
    try{
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id_area_operacion:id_area_operacion
      });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"maquina/by-area-operacion",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  };

  export const getMaquinasJustificacion = async (fecha,id_area_operacion) => {
    try{

      const month = fecha.getMonth() + 1;
      const year = fecha.getFullYear();

      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        "id_area_operacion": id_area_operacion,
        "month":month,
        "year":year
    });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/get-justificaciones",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const getMaquinasJustificadas = async (fecha,id_area_operacion) => {
    try{

      const month = fecha.getMonth() + 1;
      const year = fecha.getFullYear();

      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        "id_area_operacion": id_area_operacion,
        "month":month,
        "year":year
    });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/get-maquinas-justificadas",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const getUltimaUbicacionJustificacion = async (id_area_operacion,id_movimiento) => {
    try{

      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id_area_operacion,
        id_movimiento
    });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/get-ultima-ubicacion",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const getUbicacionesPorIdOperacion = async (id_area_operacion) => {
    try{

      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id_area_operacion,
    });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"area-operacion/get-ubicaciones",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const insertJustificacion = async (id_area_operacion,id_tipo_justificacion,observacion,fecha_inicio,fecha_termino,id_maquina,id_registro_movimiento,id_tipo_movimiento,ubicacion) => {
    try{
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");
      let raw = {
        id_area_operacion,
        id_tipo_justificacion,
        fecha_inicio,
        fecha_termino,
        id_maquina,
        id_registro_movimiento,
        id_tipo_movimiento,
        ubicacion
      };
      if(observacion && observacion != ""){
        raw.observacion = observacion
      }
   
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:JSON.stringify(raw)
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/insert",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

  export const insertJustificacionMasiva = async (id_area_operacion,id_tipo_justificacion,observacion,fecha_inicio,fecha_termino,maquinas,id_registro_movimiento,id_tipo_movimiento,ubicacion) => {
    try{
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      let raw = {
        id_area_operacion,
        id_tipo_justificacion,
        fecha_inicio,
        fecha_termino,
        maquinas,
        id_registro_movimiento,
        id_tipo_movimiento,
        ubicacion
      };
      
      if(observacion && observacion != ""){
        raw.observacion = observacion
      }

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:JSON.stringify(raw)
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/insert-masiva",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }
  export const getMaquinasJustificadasDescargar = async (fecha_inicio,fecha_termino,id_area_operacion) => {
    try{
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id_area_operacion,
        fecha_inicio,
        fecha_termino
      });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body:raw
      };
  
      const res = await fetch(
        API_GATEWAY_ENDPOINT+"justificacion/get-maquinas-justificadas-descarga",
        requestOptions
      );
  
      if (!res.ok) throw new Error(res.text());
      const json = await res.json();
      return { success: true, data: json };
    } 
    catch (e) {
      console.error(e);
      return { success: false, data: [] };
    }
  }

export async function getJustificacionPendientePerforadora(
  idAreaOperacion, 
  inicioMes, 
  finMes
) {
  try {
    const response = await fetch(
      `${API_GATEWAY_ENDPOINT}justificacion/get-justificacion-pendiente-perforadora`,
    {
      method: "POST",
      headers: {
        "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        idAreaOperacion,
        inicioMes,
        finMes
      })
    });

    if (!response.ok) {
      return {
        status: "error",
        message: "Ha ocurrido un error al intentar obtener los datos"
      }
    }

    const data = await response.json();

    return {
      status: "success",
      data
    }
    
  } catch (err) {
    return {
      status: "error",
      message: "Ha ocurrido un error al intentar obtener los datos"
    }
  }
}

export async function getJustificacionPerforadora(
  idAreaOperacion, 
  inicioMes, 
  finMes
) {
  try {
    const response = await fetch(
      `${API_GATEWAY_ENDPOINT}justificacion/get-justificacion-perforadora`,
    {
      method: "POST",
      headers: {
        "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        idAreaOperacion,
        inicioMes,
        finMes
      })
    });

    if (!response.ok) {
      return {
        status: "error",
        message: "Ha ocurrido un error al intentar obtener los datos"
      }
    }

    const data = await response.json();

    return {
      status: "success",
      data
    }
    
  } catch (err) {
    return {
      status: "error",
      message: "Ha ocurrido un error al intentar obtener los datos"
    }
  }
}

export async function justificarPerforadora(perforadoraPendiente, idJustificacion, ultimaUbicacion) {
  try {
    const response = await fetch(
      `${API_GATEWAY_ENDPOINT}justificacion/justificar-perforadora`,
    {
      method: "POST",
      headers: {
        "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        idJustificacion,
        perforadoraPendiente,
        ultimaUbicacion
      })
    });

    if (!response.ok) {
      return {
        status: "error",
        message: "Ha ocurrido un error al intentar justificar la información."
      }
    }

    const data = await response.json();

    return {
      status: "success",
      data
    }
    
  } catch (err) {
    return {
      status: "error",
      message: "Ha ocurrido un error al intentar justificar la información."
    }
  }
}

export async function getUltimaUbicacionPerforadoraByFecha(idMaquina, fechaInicio, horaInicio) {
  try {
    const response = await fetch(
      `${API_GATEWAY_ENDPOINT}justificacion/get-ultima-ubicacion-perforadora`,
    {
      method: "POST",
      headers: {
        "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        idMaquina,
        fechaInicio,
        horaInicio
      })
    });

    if (!response.ok) {
      return {
        status: "error",
        message: "Ha ocurrido un error al intentar obtener los datos"
      }
    }

    const data = await response.json();

    return {
      status: "success",
      data
    }
    
  } catch (err) {
    return {
      status: "error",
      message: "Ha ocurrido un error al intentar obtener los datos"
    }
  }
}

export async function getHorometroMotorJustificacion(idMaquina, day) {
  try {
    const response = await fetch(
      `${API_GATEWAY_ENDPOINT}justificacion/get-horometro-motor-justificacion`,
    {
      method: "POST",
      headers: {
        "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        idMaquina,
        day
      })
    });

    if (!response.ok) {
      return {
        status: "error",
        message: "Ha ocurrido un error al intentar obtener los datos"
      }
    }

    const data = await response.json();

    return {
      status: "success",
      data
    }
    
  } catch (err) {
    return {
      status: "error",
      message: "Ha ocurrido un error al intentar obtener los datos"
    }
  }
}